var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":_vm.favoritesByKey[_vm.favorite]}}),_c('div',{staticClass:"container-fluid"},[_c(_vm.compName,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }